import './live-inside.scss'
// hooks
import useLive from '../../../hooks/useLive'
import useUIActions from '../../../../../hooks/useUIActions'
// utils
import sendGaPush from '../../../../../utils/sendGaPush'
// components
import CardOverlay from '../../../../../components/molecules/cards/card-overlay/card-overlay'
import CardHorizontal from '../../../../../components/molecules/cards/card-horizontal/card-horizontal'
import Image from '../../../../../components/atoms/Image/image'
import Button from '../../../../../components/atoms/button/button'
import Loading from '../../../../../components/atoms/loading/loading'
import BlankPage from '../../../../../components/atoms/blank-page/blank-page'

const LiveInside = props => {
	const { id, beneficioCollection: { items } = {} } = props

	// hooks
	const {
		liveState: { allDataLive, loading },
		liveActions: { controlLive, reserveLives }
	} = useLive({
		idInsideLive: id
	})
	const { hideOverlay } = useUIActions()

	const content = items?.find(e => e.idReto === id) || items[0] || false
	const contentSlider = items?.filter(e => e.idReto !== id)

	const {
		imagen: img,
		descripcion2: description,
		icono: icon,
		titulo3: profesional,
		titulo2: liveTitle,
		descripcion3: education,
		textoBotonSecundario: buttonText
	} = content || false

	// metrics
	const handleSendGaPush = ({ action = 'clickEnvivoSlider', label }) => {
		sendGaPush({ category: 'SaludContinuarediseno', action, label })
	}

	// actions
	const goLive = url => {
		if (!url) return null

		window.open(url, '__blank')
	}

	// render
	const HeadContent = (
		<div className='m-live-inside__head'>
			<span>LIVE</span>
			<h4>{liveTitle}</h4>
			<Button
				title={buttonText}
				classes='pink mt1'
				onClick={() => {
					handleSendGaPush({ label: buttonText })
					allDataLive[0] ? goLive(allDataLive[0].meetingUrl) : reserveLives(id)
				}}
			/>
		</div>
	)

	if (!content) return <BlankPage />

	return (
		<CardOverlay headerContent={loading ? <Loading small={true} /> : HeadContent} img={img?.url}>
			<section className='m-live-inside container pt0'>
				<p>{description}</p>
				<div className='m-live-inside__header'>
					<Image src={icon.url} width='33' atl={description} classes='mr1' />
					<p>
						<strong>Profesor:</strong> {profesional}
						<br />
						{education}
					</p>
				</div>
				{contentSlider?.length > 0 && (
					<div>
						<h3>Próximos en vivo</h3>
						{contentSlider?.map(live => (
							<CardHorizontal
								key={live.titulo2}
								img={live.imagen.url}
								title={live.titulo2}
								buttonText={live.textoBoton}
								hour={live.tituloCard}
								date={live.descripcionGeneral}
								onClick={() => {
									hideOverlay()
									handleSendGaPush({ label: live.titulo2 })
									controlLive({ id: live.idReto })
								}}
							/>
						))}
					</div>
				)}
			</section>
		</CardOverlay>
	)
}

export default LiveInside
